import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { AlertService } from "src/app/common/components/alert/alert.service";
import { apiEndPoints } from "src/app/common/constants/api-endpointsconstant";
import { ApiService } from "src/app/common/services/api.service";
import { SharedService } from "src/app/common/services/shared.service";
import { ReportService } from "src/app/reports/services/report.service";
import { environment } from "src/environments/environment";


@Injectable({
  providedIn: 'root',
})
export class CommonPropertyDetailPageService {
  constructor(
    private apiService: ApiService,
    private reportService: ReportService,
    public translate: TranslateService
  ) {}

getPropertyRental(
  limit:number,
  offset:number,
  sortOrder: string,
  propertyUid: string = '',
  type: 'residential' | 'retail' | 'office' | 'warehouse'|'land_price' | 'property_price' | 'unit_price'
) {
  let queryParams = { ...this.reportService.queryParams };
  // const changeParams = this.reportService.setfilterQueryParams(queryParams);
  let url: string = `${environment.miUrl}${apiEndPoints.propertyDetailsRental}?limit=${limit}&offset=${offset}&property_uid=${propertyUid}&type=${type}`;
  if(queryParams?.rid){
    url += `&report_id=${queryParams?.rid}`;
  }
  if (sortOrder) {
    url += `&sort_order=${sortOrder}`;
  }
  if(offset == 0){
    url += "&is_count=true"
  }
  return this.apiService.get(url, false);
}

/**
   * Get property amenities list
   * @param property_uid
   * @returns
   */
  getPropertyAmneities(property_uid:string){
    let url = `${environment.miUrl}${apiEndPoints.PropertyAmenities}?property_uid=${property_uid}`
    return this.apiService.get(url)
  }

  getLandPriceAnalysis(property_uid:string, type:string, filter:string){
    let queryParams = { ...this.reportService.queryParams };
    let url = `${environment.miUrl}${apiEndPoints.propertyDetailLandPriceAnalysis}?property_uid=${property_uid}&report_id=${queryParams.rid}&type=${type}`;
    if(filter){
       url += `&filter=${filter}`;
    }
    return this.apiService.get(url)
  }

   getVillaPriceAnalysis(property_uid:string, type:string){
    let queryParams = { ...this.reportService.queryParams };
    let url = `${environment.miUrl}${apiEndPoints.propertyDetailVillaPriceAnalysis}?property_uid=${property_uid}&report_id=${queryParams.rid}&type=${type}`;
    return this.apiService.get(url)
  }

  getApartmentPriceAnalysis(api_end_point:string, property_uid:string, type:string, filter:string=''){
    let queryParams = { ...this.reportService.queryParams };
    let url = `${environment.miUrl}${api_end_point}?property_uid=${property_uid}&report_id=${queryParams.rid}`;
    if(type){
      url += `&type=${type}`;
    }
    if(filter){
       url += `&filter=${filter}`;
    }
    return this.apiService.get(url)
  }

  
  getPropertyLandParcel(property_uid: any, sort_order:any, limit:number, offset:number, parcel_uid:string='') {
    let queryParams = { ...this.reportService.queryParams };
    const changeParams = this.reportService.setfilterQueryParams(queryParams);
    let url: string = `${environment.miUrl}${apiEndPoints.projectDetailsLandParcel}${changeParams}&limit=${limit}&offset=${offset}&property_uid=${property_uid}&selected_parcel_uid=${parcel_uid}`;
    if (sort_order) {
      url += `&sort_order=${sort_order}`;
    }
    if(offset == 0){
      url += "&is_count=true"
    }
    return this.apiService.get(url, false);
  }
}
